// extracted by mini-css-extract-plugin
module.exports = {"itemLink":"_a09b544d","image":"_431febf"};